import * as Yup from 'yup';

export const structure = [
  {
    name: 'oldPinCode',
    validate: Yup.number()
      .required('Mật khẩu mới không được để trống')
      .test(
        'len',
        'Mật khẩu phải đủ 6 kí tư',
        (val) => val?.toString().length === 6,
      ),
  },
  {
    name: 'newPinCode',
    validate: Yup.number()
      .required('Mật khẩu mới không được để trống')
      .test(
        'len',
        'Mật khẩu phải đủ 6 kí tư',
        (val) => val?.toString().length === 6,
      ),
  },
  {
    name: 'confirmNewPinCode',
    // validate: Yup.string()
    //   .required('Vui lòng xác nhận lại mật khẩu')
    //   .test({
    //     message: 'Mật khẩu xác nhận không khớp',
    //     test: function (value: any) {
    //       const password = this.resolve(Yup.ref('newPinCode'));
    //       if (password && value && value !== password) return false;
    //       return true;
    //     },
    //   }),
    validate: Yup.number()
      .typeError('Mật khẩu phải là số')
      .test(
        'len',
        'Mật khẩu phải đủ 6 kí tư',
        (val) => val?.toString().length === 6,
      )
      .test(
        'passwords-match',
        'Mật khẩu mới không trùng khớp',
        function (value) {
          return this.parent.newPinCode === value;
        },
      ),
  },
];
